import { PopularRegionTile } from 'marketing/pages/ContentfulWebPage/PopularRegionTile'
import WhyWeLoveTile from 'marketing/pages/ContentfulWebPage/WhyWeLoveTile'
import BlogCard from 'home/components/Blog/BlogCard'
import moment from 'moment'

function ContentfulCard(props: App.ContentfulWebPageCardItem) {
  switch (props.type) {
    case 'componentPopularRegionTile':
      return (
        <PopularRegionTile
          imageId={props.imageId}
          title={props.title}
          description={props.description}
          url={props.url}
        />
      )
    case 'componentBlogCard':
      return <BlogCard
        key={props.slug}
        imageId={props.imageId}
        title={props.title}
        date={moment(props.date)}
        description={props.description}
        slug={props.slug}
        lineClamp={2}
      />
    default:
      return <WhyWeLoveTile
        imageId={props.imageId}
        title={props.title}
        description={props.description}
      />
  }
}

export default ContentfulCard
